import(/* webpackMode: "eager" */ "/var/www/frontend/app/globals.css");
import(/* webpackMode: "eager" */ "/var/www/frontend/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/var/www/frontend/src/components/antdRegistry/AntdRegistry.tsx");
import(/* webpackMode: "eager" */ "/var/www/frontend/src/utilities/styles.scss")